// extracted by mini-css-extract-plugin
module.exports = {"root":"FormError_root__2kdeX","icon":"FormError_icon__XR4Bt","text":"FormError_text__3xLAH"};